/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2021-04-20 17:09:53
 * @LastEditors: lzy
 * @FilePath: \xjmediacloud\app\editingCenter\newspaper\alertViews\ProcessRecording\ProcessRecording.js
 * @Description: 
 */
/**
 * Created by ma.rongqin 2016.3.4
 */
'use strict';
angular.module('editCenNewspaperProcessRecordingModule', [])
    .controller('editCenNewspaperProcessRecordingCtrl', ['$scope', '$modalInstance', '$state', 'trsHttpService', 'initVersionService', 'params', function($scope, $modalInstance, $state, trsHttpService, initVersionService, params) {
        initStatus();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.processVersion = { // 获取组版流程参数
                methodname: 'queryComposeLogs',
                serviceid: 'nb_ft'
            };
            $scope.operationRecord = { // 获取操作记录参数
                serviceid: 'mlf_paper',
                methodname: 'queryComposeReviewLog',
            };
        }

        /**
         * [requestData description]请求数据
         *
         * @param  {[type]}  selectedType   [selectedType description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.requestData = function (selectedType) {
            var params = Object.assign({
                ComposeId: params && params.COMPOSEPAGEINFOID ? params.COMPOSEPAGEINFOID : $state.params.composeId
            }, $scope[selectedType]);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope[selectedType + 'Items'] = initVersionService.getDayContent(data, 'push');
                $scope.items = $scope[selectedType + 'Items'];
            });
        };

        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);
